module.exports = __webpack_public_path__ + "static/img/chongqingchuban.45f8a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/chongqingchuban.png
// module id = KOFc
// module chunks = 46